import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardLayout from './DashboardLayout';
import ProjectShellLayout from './ProjectShellLayout';
import TesterShellLayout from './TesterShellLayout';
import { RoleNavProvider } from '../../context/RoleNavContext';
import { ActiveProjectProvider } from '../../context/ActiveProjectContext';
import { isStaffRole } from '../../utils/deepLink';

export default function RoleShellLayout() {
  const { user } = useSelector((state) => state.auth);
  const role = user?.role;

  if (role === 'client' || role === 'client_team' || isStaffRole(role)) {
    return (
      <ActiveProjectProvider>
        <RoleNavProvider>
          <ProjectShellLayout>
            <Outlet />
          </ProjectShellLayout>
        </RoleNavProvider>
      </ActiveProjectProvider>
    );
  }

  if (role === 'tester') {
    return (
      <RoleNavProvider>
        <TesterShellLayout>
          <Outlet />
        </TesterShellLayout>
      </RoleNavProvider>
    );
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
